module.exports = __webpack_public_path__ + "img/bhushan.6206013b.png";